import type { ConversationStatus } from "@redotech/effect-api-shared/models/shopper-ai/conversation/conversation";

/**
 * Human-readable labels for conversation statuses.
 */
export const ConversationStatusReadable: Record<ConversationStatus, string> = {
  OPEN: "Open",
  CLOSED: "Closed",
  SNOOZED: "Snoozed",
  IN_PROGRESS: "In Progress",
  HIDDEN: "Hidden",
  ARCHIVED: "Archived",
  DELETED: "Deleted",
};
